import React from 'react';
import OsScroll from '../ui/OsScroll';

/**
 * The request editor's tab content area.
 *
 * `fixed` tabs (Body, Script) host their own editor that scrolls itself, so the
 * area only clips. Every other tab — Params, Headers, Authorization, Cookies —
 * scrolls through OsScroll (OverlayScrollbars), never the native `panel-scroll`
 * bar: on macOS WKWebView that one turns back into the wide system scrollbar
 * the moment the pointer hovers it (see ui/OsScroll.js).
 */
export default function RequestTabBody({ fixed, children }) {
  if (fixed) {
    return (
      <div className="flex-1 min-h-0 overflow-hidden px-0 pt-3 pb-4" data-testid="request-tab-body">
        {children}
      </div>
    );
  }
  return (
    <OsScroll className="flex-1 min-h-0 editor-tab-body" data-testid="request-tab-body">
      {children}
    </OsScroll>
  );
}
